export default "https://assets.stage.yurplan.com/yurplan-v1/dist/msg-box__icon--warning.6ae565ca8fdbcad2c7b30b676479f755.svg";